import { Injectable } from '@angular/core';
import { environment } from '../environment/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ImportGuard {
  constructor(protected router: Router) {}

  canActivate(){
    if(environment.importIscritti){
      return true;
    }
    else{
      this.router.navigate(['/']);
      return false;
    }
  }
}
